import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useList} from 'react-use';
import lodash from 'lodash';
import _ from 'lodash';
import Checkbox from "../../../../components/checkbox";

const getNumCheck = (value) => {
    let i = 0;
    lodash.filter(value,item => {
        if(item.check) i++;
    })
    return i;
}

function CategorySection(props) {
    const {selected, error} = props;
    const ref = useRef(null);
    const [totalCondition, setTotalCondition] = useState({
        regularSeason: selected.regularSeason,
        postSeason: selected.postSeason
    })
    const [isCheckTotalPost, setIsCheckTotalPost] = useState(false);
    const [isCheckRegular, setIsCheckRegular] = useState(false);
    const [listCategory] = useList([
        {
            id: 4,
            name: '日本シリーズ',
            checked: false,
        },
        {
            id: 2,
            name: 'クライマックスシリーズ',
            checked: false,
        }
    ]);
    useEffect(() => {
        if (selected.regularSeason) {
            setIsCheckRegular(true)
        }else {
            setIsCheckRegular(false)
        }
        if (selected.postSeason && selected.postSeason.length > 0) {
            selected.postSeason.map(item => {
                const index = listCategory.findIndex(i => i.id === item);
                listCategory[index].check = true;
            })
            if (selected.postSeason.length === listCategory.length) setIsCheckTotalPost(true);
        }

    }, [selected])
    useEffect(() => {
        props.onChange(totalCondition)
    }, [totalCondition])
    useEffect(() => {
        if (_.isEmpty(totalCondition.postSeason)) {
            setIsCheckTotalPost(false);
            return
        }
        if(totalCondition.postSeason.length !== getNumCheck(totalCondition.postSeason)) {
            setIsCheckTotalPost(false);
        }
    }, [totalCondition.postSeason]);

    const onClickStraight = useCallback((e) => {
        const val = Number(e.target.id);
        setIsCheckRegular(!isCheckRegular);
        setTotalCondition(state => ({...state, regularSeason: state.regularSeason ? null : val}))
    }, []);

    const onClickTotalSphere = useCallback(() => {
        setIsCheckTotalPost(!isCheckTotalPost);
        if (!isCheckTotalPost) {
            const arr = [];
            const cpList = [...listCategory];
            cpList.forEach(i => {
                arr.push(i.id);
                i.check = true
            })
            setTotalCondition(state => ({...state, postSeason: arr}))
        } else {
            const cpList = [...listCategory];
            cpList.forEach(i => {
                i.check = false
            })
            setTotalCondition(state => ({...state, postSeason: []}))
        }

    }, [isCheckTotalPost])

    const onCheckSphere = useCallback((val) => {
        const arr = [...totalCondition.postSeason];
        const cpList = [...listCategory];

        const index = _.indexOf(arr, Number(val));
        const i = _.findIndex(cpList, item => item.id === Number(val))
        if (index === -1) {
            arr.push(Number(val));
            cpList[i].check = true;
        } else {
            arr.splice(index, 1);
            cpList[i].check = false;
        }
        setTotalCondition(state => ({...state, postSeason: arr}));
    })

    return <div ref={ref} className='item-group-btn'>
        <h3 className='navbar-item'>カテゴリ選択</h3>
        <div style={{ display: 'grid' }}>
            <label style={{ display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'}}>
                <Checkbox id='1' checked={isCheckRegular} onClick={onClickStraight} />
                レギュラーシーズン
            </label>
            <label style={{ display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'}}>
                <Checkbox id='2' checked={isCheckTotalPost} onClick={onClickTotalSphere} />
                ポストシーズン
            </label>
        </div>
            <div className='item-group' style={{ padding: 0}}>
                {listCategory.map((item) => {
                  return <div key={item.value} className={'search-main-advanced-checkbox'}>
                        <label>
                            <Checkbox checked={item.check} onClick={() => onCheckSphere(item.id)}/>
                            {item.name}
                        </label>
                    </div>
                })}
            </div>
        <div className='err-validate-advance-search'>
            {error && <h4 className='navbar-item err-label' style={{paddingBottom: 30}}>カテゴリ選択{error.message}</h4>}
        </div>
    </div>
}

export default CategorySection;
